import { render, staticRenderFns } from "./SellersManagement.vue?vue&type=template&id=1bc11390"
import script from "./SellersManagement.vue?vue&type=script&lang=js"
export * from "./SellersManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports